import PropTypes from 'prop-types'
import Styles from './IFGroupingComponent.module.css'
import { IFText } from 'Components'
import { Colors } from 'Theme'
import { useTranslation } from 'react-i18next'

const IFGroupingComponent = ({ componentText, style = {} }) => {
  const { t } = useTranslation()
  const pickedDetails = componentText || []
  const first =
    pickedDetails[0] || t('OperatorUserListItem.NoPermissionsSelected')

  return (
    <div
      style={{ backgroundColor: Colors.GreyBackground, ...style }}
      className={Styles.PermissionsDiv}
    >
      <IFText className={Styles.RenderText}>{first}</IFText>
      {pickedDetails.length > 1 && (
        <IFText style={{ flexShrink: 0 }}>{`+${
          pickedDetails.length - 1
        }`}</IFText>
      )}
    </div>
  )
}

IFGroupingComponent.propTypes = {
  componentText: PropTypes.string.isRequired,
  style: PropTypes.object,
}
export default IFGroupingComponent
